import React  from 'react';
import Classes from "classnames";

export default function renderEmailGroupListHeader(id, props) {
    const { data, className } = props;

    const classes = Classes(className, 'gd-field-email-group-list-header', {
        'no-value': !data.value
    });

    return (
        <div className={classes}>
            {!!data.value && <div className="group-list-header-icon i5-email"> </div>}
            <div className="group-list-header-value">{data.value ? data.value : "Not set"}</div>
        </div>
    );
}